import * as React from 'react'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
import { Alert } from '../../../../common/Alert/Alert'

export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        const { values } = this.props
        this.state = {
            values: values,
            dirty: false,
            errorList: [],
            errFields: [],
            showErrorOfCovar: false,
            employerLiabilityWagerollCheck: values.employerLiabilityWageroll > 0 || values.employee > 0,
        }
    }

    handleCheckbox = () => {
        return true
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, prevContext: any): void {
        const { values } = this.props
        if (prevProps.values !== values) {
            this.setState({ values })
        }
    }

    handleItemChange = (field: string, value: any) => {
        if (this.props.dirty) {
            this.props.dirty(true)
        }

        if (field === 'employerLiabilityWagerollCheck') {
            this.setState((prevState) => ({
                values: {
                    ...prevState.values,
                    employerLiabilityWageroll: value ? prevState.values.employerLiabilityWageroll : '',
                    employee: value ? prevState.values.employee : '',
                },
                [field]: value,
                dirty: true,
            }))
        } else {
            this.setState((prevState) => ({
                values: { ...prevState.values, [field]: value },
                dirty: true,
            }))
        }
    }

    handleSubmit = (event: any) => {
        event.preventDefault()
        let errorList: any = []
        let errFields: string[] = []

        const checkAmount = (item: any, value: any, fieldsVal: string) => {
            if ((value !== null && value === 0) || !value) {
                errorList.push(item.toString())
                errFields.push(fieldsVal)
            }
        }

        if (this.state.employerLiabilityWagerollCheck) {
            checkAmount('No of employees', this.state.values.employee, 'employee')
        }

        if (errorList.length !== 0) {
            this.setState({ errorList, errFields })
        } else {
            this.props.handleAdjustChangeOptions(this.state.values)
            this.setState({ dirty: false, errorList: [], errFields: [] })
            if (this.props.dirty) {
                this.props.dirty(false)
            }
        }
    }

    render() {
        const {
            terrorism,
            legalCover,
            employee,
            employerLiabilityWageroll,
            employerLiabilityType,
            ernNumber,
        } = this.state.values
        const { errFields, errorList, employerLiabilityWagerollCheck } = this.state
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                      ${this.state.dirty ? 'plus57' : null}`}
                >
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >

                        {errorList.length !== 0 &&
                            <Alert
                                type="error"
                                className={`errorMessage ${(errorList.length) ? 'visible' : ''}`}
                            >
                                <p>
                                    Cover options not allowed zero:
                                    {errorList.map((a, i) => (a + ' '))}
                                </p>
                            </Alert>}
                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={terrorism || false}
                            value={terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>
                        <OptionsCheckbox
                            id="legalCover"
                            title="Add legal cover"
                            handleItemChange={this.handleItemChange}
                            checked={legalCover || false}
                            value={legalCover}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>
                        <OptionsCheckbox
                            id="employerLiabilityWagerollCheck"
                            title="Add Employers Liability? (10m)"
                            handleItemChange={this.handleItemChange}
                            checked={
                                employerLiabilityWagerollCheck || (employerLiabilityWageroll ? true : false) || false}
                            value={employerLiabilityWagerollCheck}
                            tooltipView={false}
                        />

                        <div
                            className={`options__item item_group 
                                ${!(employerLiabilityWagerollCheck) ?
                                    `hidden` : ``}
                            emp_item_group`}
                        >
                            <div className="input_group">
                                <div className="input_group_sec left">
                                    <div className="input_sec">
                                        <label>Enter wage roll *</label>
                                        <div
                                            className={`input 
                                         ${(employerLiabilityWagerollCheck &&
                                                    errFields.includes('employerLiabilityWageroll')) ?
                                                    'error_border' : ''}`}
                                        >
                                            <div className="pound">&pound;</div>
                                            <input
                                                name="employerLiabilityWageroll"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('employerLiabilityWageroll', v)
                                                }}
                                                value={employerLiabilityWageroll}
                                            />
                                        </div>
                                    </div>
                                    <div className="input_sec">
                                        <label>Number of employees</label>
                                        <div
                                            className={`input input__no-symbol
                                         ${(employerLiabilityWagerollCheck && errFields.includes('employee')) ?
                                                    'error_border' : ''}`}
                                        >
                                            <input
                                                name="employee"
                                                placeholder="0"
                                                type="number"
                                                min="0"
                                                step="any"
                                                onChange={(event) => {
                                                    let v = Number(event.target.value)
                                                    this.handleItemChange('employee', v)
                                                }}
                                                value={employee}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="empolyee_group item-col-2">
                                <div className="col1">
                                    <div className="switchies">
                                        <div
                                            className={`switch
                                        ${(!['Client is exempt', 'Unknown'].includes(employerLiabilityType)) ?
                                                    `selected` :
                                                    ``}`}
                                            onClick={() => {
                                                this.handleItemChange('employerLiabilityType', 'Enter ERN number')
                                            }}
                                        >
                                            Enter ERN number
                                        </div>
                                        <div
                                            className={`switch
                                        ${(employerLiabilityType === 'Client is exempt') ?
                                                    `selected` :
                                                    ``}`}
                                            onClick={() => {
                                                this.handleItemChange('employerLiabilityType', 'Client is exempt')
                                            }}
                                        >
                                            Client is exempt
                                        </div>
                                        <div
                                            className={`switch
                                        ${(employerLiabilityType === 'Unknown') ?
                                                    `selected` :
                                                    ``}`}
                                            onClick={() => {
                                                this.handleItemChange('employerLiabilityType', 'Unknown')
                                            }}
                                        >
                                            Unknown
                                        </div>
                                    </div>
                                </div>
                                <div className="col2">
                                    <div className="input input__no-symbol">
                                        <input
                                            type="text"
                                            placeholder="Type here..."
                                            min="0"
                                            step="any"
                                            onChange={
                                                (event) => {
                                                    let v = event.target.value
                                                    this.handleItemChange('ernNumber', v)
                                                }}
                                            value={ernNumber}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05cp/components/VariationOptions.tsx